<template>
    <div class="language-switcher flags">
        <a
                v-for="lang in languages" :key="lang"
                href="#"
                @click.prevent="setLanguage(lang)">

            <img :src="flag(lang)">
        </a>
    </div>
</template>
<script>
    export default {
        props: {
            big: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                languages: [
                    'da',
                    'en',
                    //'de'
                ]
            }
        },
        computed: {
            size() {
                return (this.big ? '32' : '24');
            },
            inactiveLanguages(){
                let active = this.activeLang;
                return this.languages.filter(l => l != active)
            },
            activeLang(){
                return this.$polyglot.lang;
            }
        },
        methods: {
            flag(lang) {
                return "/static/icons/language/" + lang + "-" + this.size + ".png";
            },
            setLanguage(lang){
                this.$store.dispatch("setLanguage", lang)
            }
        }
    }
</script>
<style scoped>
    .flags img {
        margin-left: 6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/snippets/language-switcher.vue